import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
//import Mgr from "./oidc/SecurityService";
Vue.use(Router);

const router = new Router({
	mode: "history",
	linkExactActiveClass: "vue-school-active-class",
	//scrollBehavior(to, from, savedPosition)
	//{
	//    return { x: 0, y: 0 };
	//},
	routes: [
		{
			path: "/",
			name: "home",
			component: () =>
				import(/* webpackChunkName: "Home" */ "./views/Home.vue")
		},
		{
			path: "/content/:slug",
			name: "content",
			component: () =>
				import(/* webpackChunkName: "Content" */ "./views/Content.vue")
		},
		{
			path: "/auth",
			name: "auth",
			component: () =>
				import(/* webpackChunkName: "Login" */ "./views/Auth.vue")
		},
		{
			path: "/auth/signin-oidc",
			name: "signinOidc",
			component: () =>
				import(
					/* webpackChunkName: "Login" */ "./views/auth/SigninOidc.vue"
				)
		},
		{
			path: "/auth/silent-renew",
			name: "silentRenew",
			component: () =>
				import(
					/* webpackChunkName: "Login" */ "./views/auth/SilentRenew.vue"
				)
		},
		{
			path: "/club/:action/:id?",
			name: "club",
			component: () =>
				import(/* webpackChunkName: "Club" */ "./views/Club"),
			meta: { requiresAuth: true, role: "User" }
		},
		{
			path: "/products/:id?/:name?",
			name: "products",
			component: () =>
				import(
					/* webpackChunkName: "Products" */ "./views/Products.vue"
				)
		},
		{
			path: "/shops/:provinceId?/:shopCategoryId?/:name?",
			name: "shops",
			component: () =>
				import(/* webpackChunkName: "Shops" */ "./views/Shops.vue")
		},
		{
			path: "/shop/:id/:name",
			name: "shop",
			component: () =>
				import(/* webpackChunkName: "Shop" */ "./views/Shop.vue")
		},
		{
			path: "/product/:id/:name",
			name: "product",
			component: () =>
				import(/* webpackChunkName: "Shop" */ "./views/Product.vue")
		},
		{
			path: "/blog",
			name: "blog",
			component: () =>
				import(/* webpackChunkName: "Blog" */ "./views/Blog.vue")
		},
		{
			path: "/services",
			name: "services",
			component: () =>
				import(
					/* webpackChunkName: "Services" */ "./views/Services.vue"
				)
		},
		{
			path: "/faq",
			name: "faq",
			component: () =>
				import(/* webpackChunkName: "Faq" */ "./views/Faq.vue")
		},
		{
			path: "/cart",
			name: "cart",
			component: () =>
				import(/* webpackChunkName: "Cart" */ "./views/Cart.vue")
		},
		{
			path: "/404",
			alias: "*",
			name: "notFound",
			component: () =>
				import(
					/* webpackChunkName: "NotFound" */
					"./views/NotFound"
				)
		}
	]
});

//var mgr = new Mgr();
//router.beforeEach((to, from, next) =>
//{
//	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//	if (requiresAuth)
//	{
//		mgr.getRole().then(
//			sucess =>
//			{
//				if (to.meta.role == sucess)
//				{
//					next();
//				} else
//				{
//					next({
//						name: "auth",
//						query: { redirect: to.fullPath }
//					});
//				}
//			},
//			err =>
//			{
//				console.log(err);
//			}
//		);
//	} else
//	{
//		next();
//	}

//	next();
//});

router.beforeEach((to, from, next) =>
{
	if (to.matched.some(record => record.meta.requiresAuth))
	{
		if (
			localStorage.getItem("__fcp") != null &&
			to &&
			to.path != "/club/resetPassword"
		)
		{
			next({
				name: "club",
				params: {
					action: "resetPassword"
				}
			});
		} else
		{
			if (!store.token)
			{
				next({
					name: "auth",
					query: { redirect: to.fullPath }
				});
			} else
			{
				next();
			}
		}
	} else
	{
		next();
	}
});

export default router;
